import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast.success('Message sent successfully! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://customer-assets.emergentagent.com/job_ec527428-3aec-42a4-a1f7-d2e66c0be0df/artifacts/hktez0bk_logo_transs.png" 
                alt="doorush logo" 
                className="h-10 w-auto"
              />
            </div>
            <Button onClick={() => navigate('/')} variant="outline" className="border-2 border-[#007e7a] text-[#007e7a] hover:bg-[#007e7a] hover:text-white">
              Back to Home
            </Button>
          </div>
        </div>
      </header>

      {/* Contact Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            <Card className="p-6 hover:shadow-xl transition-shadow duration-300">
              <CardContent className="text-center pt-6">
                <div className="w-16 h-16 bg-[#007e7a]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Mail className="text-[#007e7a]" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Email Us</h3>
                <p className="text-gray-600">support@doorush.in</p>
              </CardContent>
            </Card>

            <Card className="p-6 hover:shadow-xl transition-shadow duration-300">
              <CardContent className="text-center pt-6">
                <div className="w-16 h-16 bg-[#007e7a]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Phone className="text-[#007e7a]" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Call Us</h3>
                <p className="text-gray-600">+91 9092963743</p>
                <p className="text-gray-600">Support Available</p>
              </CardContent>
            </Card>

            <Card className="p-6 hover:shadow-xl transition-shadow duration-300">
              <CardContent className="text-center pt-6">
                <div className="w-16 h-16 bg-[#007e7a]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MapPin className="text-[#007e7a]" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Visit Us</h3>
                <p className="text-gray-600">1st floor, 1/2A, 12-B, 1st Main Road</p>
                <p className="text-gray-600">Sowmya Nagar, Perumbakkam</p>
                <p className="text-gray-600">Chennai - 600100</p>
              </CardContent>
            </Card>
          </div>

          {/* <Card className="max-w-3xl mx-auto p-8">
            <CardContent>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                    <Input 
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe" 
                      required
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                    <Input 
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com" 
                      required
                      className="w-full"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                  <Input 
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210" 
                    required
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <Textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help you..." 
                    rows={6}
                    required
                    className="w-full"
                  />
                </div>
                <Button 
                  type="submit"
                  className="w-full bg-[#007e7a] hover:bg-[#006666] text-white text-lg py-6"
                >
                  <Send className="mr-2" size={20} />
                  Send Message
                </Button>
              </form>
            </CardContent>
          </Card> */}
        </div>
      </section>
    </div>
  );
};

export default Contact;